/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getClassroom = /* GraphQL */ `
  query GetClassroom($classroomId: String!, $providerArn: String) {
    getClassroom(classroomId: $classroomId, providerArn: $providerArn) {
      classroom {
        classroomId
        classroomArn
        langLocale
        courseId
        providerArn
        courseTitle
        courseAbstract
        courseDescription
        courseLevel
        startsOn
        endsOn
        locationData {
          timezone
          locationType
          virtualUrl
          physicalAddress {
            addressLine1
            addressLine2
            city
            state
            postalCode
            country
            __typename
          }
          source
          __typename
        }
        studentGuide {
          custom_vbid
          __typename
        }
        callsToAction {
          locationType
          url
          label
          actionType
          icon
          iconPosition
          __typename
        }
        accessCodes {
          accessCode
          accessCodeCapacity
          accessCodeCapacityUsed
          __typename
        }
        classCapacity
        studentCount
        supportedRegions
        createdBy
        accessType
        isCancellable
        subProviderCapacity {
          subProviderArn
          capacity
          subProviderStudentCount
          __typename
        }
        learningActivityID
        __typename
      }
      course {
        courseId
        title
        description
        langLocale
        abstract
        level
        __typename
      }
      content {
        contentId
        title
        description
        level
        duration
        durationUnit
        isActive
        supportedRegions
        __typename
      }
      jamTrainings {
        trainings {
          context
          trainingId
          trainingType
          contentId
          requestClientToken
          isActive
          fulfillmentStatus
          fulfillmentError {
            message
            code
            __typename
          }
          created
          lastUpdate
          metaData {
            eventId
            eventCode
            eventStatus
            testCloneEventId
            testCloneEventCode
            testCloneEventSuffix
            startsOn
            endsOn
            timezone
            maxTeamSize
            maxExpectedParticipants
            eventURL
            testEventURL
            adminEventURL
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const getStudentTrainingsByClassroomId = /* GraphQL */ `
  query GetStudentTrainingsByClassroomId(
    $classroomId: String!
    $accessType: AccessType
    $providerArn: String
  ) {
    getStudentTrainingsByClassroomId(
      classroomId: $classroomId
      accessType: $accessType
      providerArn: $providerArn
    ) {
      studentTrainings {
        lastUpdated
        metaData {
          preferredLangLocale
          labId
          labUrl
          labStatus
          region
          labRegions
          targetRegions
          __typename
        }
        trainingId
        context
        created
        requestClientToken
        arn
        state
        fulfillmentStatus
        fulfillmentError {
          message
          name
          __typename
        }
        bunsenLabStatus
        userKey
        studentNumber
        firstName
        lastName
        email
        trainingType
        __typename
      }
      __typename
    }
  }
`;
export const getIngressUrl = /* GraphQL */ `
  query GetIngressUrl($input: GetIngressUrlInput!) {
    getIngressUrl(input: $input) {
      labId
      consoleUrl
      endsOn
      status
      __typename
    }
  }
`;
export const getCourseVersions = /* GraphQL */ `
  query GetCourseVersions($input: GetCourseVersionsInput!) {
    getCourseVersions(input: $input) {
      courseVersions {
        courseId
        versionId
        createdOn
        status
        availability
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCourseVersion = /* GraphQL */ `
  query GetCourseVersion($courseVersionId: String!, $providerArn: String) {
    getCourseVersion(
      courseVersionId: $courseVersionId
      providerArn: $providerArn
    ) {
      courseVersion {
        courseVersionId
        createdOn
        availability
        status
        courseName
        supportedLocales
        blueprintData {
          blueprintName
          arn
          __typename
        }
        resourceData {
          locale
          description
          title
          __typename
        }
        contentVersion
        jamConfig {
          challengeSetID
          __typename
        }
        contentTypes
        __typename
      }
      __typename
    }
  }
`;
export const getProviderArns = /* GraphQL */ `
  query GetProviderArns {
    getProviderArns {
      providers
      __typename
    }
  }
`;
export const getProvider = /* GraphQL */ `
  query GetProvider($input: GetProviderInput!) {
    getProvider(input: $input) {
      provider {
        name
        arn
        type
        subProviderData {
          providerName
          providerType
          providerArn
          providerMetaData {
            isParentProvider
            parentProviderArn
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const getServiceSchedule = /* GraphQL */ `
  query GetServiceSchedule($input: GetServiceScheduleInput!) {
    getServiceSchedule(input: $input) {
      schedules {
        service
        domain
        endTime
        startTime
        event
        type
        __typename
      }
      __typename
    }
  }
`;
export const getProviderReport = /* GraphQL */ `
  query GetProviderReport($input: GetProviderReportInput!) {
    getProviderReport(input: $input) {
      presignedUrl
      __typename
    }
  }
`;
export const getTrainingConfiguration = /* GraphQL */ `
  query GetTrainingConfiguration($input: GetTrainingConfigurationInput!) {
    getTrainingConfiguration(input: $input) {
      context
      contentArn
      contentType
      configuration {
        targetRegions
        __typename
      }
      __typename
    }
  }
`;
export const listUserRelationships = /* GraphQL */ `
  query ListUserRelationships($input: ListUserRelationshipsInput!) {
    listUserRelationships(input: $input) {
      relationships
      __typename
    }
  }
`;
export const listClassroomRelationships = /* GraphQL */ `
  query ListClassroomRelationships($input: ListClassroomRelationshipsInput!) {
    listClassroomRelationships(input: $input) {
      classroomUsers {
        email
        userKey
        firstName
        lastName
        hasAcceptedInvitation
        eKitLicensedProviderArn
        __typename
      }
      emails
      __typename
    }
  }
`;
export const listUserClassrooms = /* GraphQL */ `
  query ListUserClassrooms($input: ListClassroomsInput!) {
    listUserClassrooms(input: $input) {
      classrooms {
        classroomArn
        providerArn
        langLocale
        courseId
        startsOn
        endsOn
        locationData {
          timezone
          locationType
          virtualUrl
          physicalAddress {
            addressLine1
            addressLine2
            city
            state
            postalCode
            country
            __typename
          }
          source
          __typename
        }
        courseTitle
        createdByEmail
        instructorEmails
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listProviderClassrooms = /* GraphQL */ `
  query ListProviderClassrooms($input: ListClassroomsInput!) {
    listProviderClassrooms(input: $input) {
      classrooms {
        classroomArn
        providerArn
        langLocale
        courseId
        startsOn
        endsOn
        locationData {
          timezone
          locationType
          virtualUrl
          physicalAddress {
            addressLine1
            addressLine2
            city
            state
            postalCode
            country
            __typename
          }
          source
          __typename
        }
        courseTitle
        createdByEmail
        instructorEmails
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listProviderReports = /* GraphQL */ `
  query ListProviderReports($input: ListProviderReportsInput!) {
    listProviderReports(input: $input) {
      iltReports {
        reportId
        reportName
        reportDate
        reportDescription
        createdDate
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listCourses = /* GraphQL */ `
  query ListCourses($input: ListCoursesInput!) {
    listCourses(input: $input) {
      courses {
        title
        id
        __typename
      }
      __typename
    }
  }
`;
export const listMajorCourseVersions = /* GraphQL */ `
  query ListMajorCourseVersions($input: ListMajorCourseVersionsInput) {
    listMajorCourseVersions(input: $input) {
      collections {
        collectionArn
        collectionTitle
        supportedLangLocales
        courseTemplatePk
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listInstructorClassroomsV2 = /* GraphQL */ `
  query ListInstructorClassroomsV2($input: ListInstructorClassroomsV2Input!) {
    listInstructorClassroomsV2(input: $input) {
      classrooms {
        classroomArn
        providerArn
        langLocale
        courseId
        startsOn
        endsOn
        locationData {
          timezone
          locationType
          virtualUrl
          physicalAddress {
            addressLine1
            addressLine2
            city
            state
            postalCode
            country
            __typename
          }
          source
          __typename
        }
        courseTitle
        createdByEmail
        instructorEmails
        __typename
      }
      count
      countType
      aggregations {
        courseTitle {
          items {
            value
            count
            __typename
          }
          countType
          __typename
        }
        langLocale {
          items {
            value
            count
            __typename
          }
          countType
          __typename
        }
        country {
          items {
            value
            count
            __typename
          }
          countType
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const listProviderClassroomsV2 = /* GraphQL */ `
  query ListProviderClassroomsV2($input: ListProviderClassroomsV2Input!) {
    listProviderClassroomsV2(input: $input) {
      classrooms {
        classroomArn
        providerArn
        langLocale
        courseId
        startsOn
        endsOn
        locationData {
          timezone
          locationType
          virtualUrl
          physicalAddress {
            addressLine1
            addressLine2
            city
            state
            postalCode
            country
            __typename
          }
          source
          __typename
        }
        courseTitle
        createdByEmail
        instructorEmails
        __typename
      }
      count
      countType
      aggregations {
        courseTitle {
          items {
            value
            count
            __typename
          }
          countType
          __typename
        }
        langLocale {
          items {
            value
            count
            __typename
          }
          countType
          __typename
        }
        country {
          items {
            value
            count
            __typename
          }
          countType
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const requiresReset = /* GraphQL */ `
  query RequiresReset {
    requiresReset {
      requiresReset
      __typename
    }
  }
`;
export const courseVirtualSKUInfo = /* GraphQL */ `
  query CourseVirtualSKUInfo($input: CourseVirtualSKUInfoInput!) {
    courseVirtualSKUInfo(input: $input) {
      productId
      availableQuantity
      __typename
    }
  }
`;
export const getLearningActivity = /* GraphQL */ `
  query GetLearningActivity($input: GetLearningActivityInput!) {
    getLearningActivity(input: $input) {
      pk
      attendedCounter
      activity_audience
      activity_modality
      activity_name
      activity_status
      activity_type
      class_size
      course_name
      customers {
        customer_name
        sfdc_account_id
        training_briefing {
          what_the_customer_does
          where_are_they_in_their_cloud_journey
          motivations_for_using_aws
          special_needs_for_training_delivery
          __typename
        }
        __typename
      }
      delivery_address_1
      delivery_address_2
      delivery_city
      delivery_country
      delivery_geo
      delivery_language
      delivery_postal_code
      delivery_region
      delivery_sessions {
        id
        start_timestamp
        end_timestamp
        __typename
      }
      delivery_state
      delivery_timezone
      instructors {
        role
        pk
        type
        email
        __typename
      }
      program
      record_type
      classrooms_student_url
      classrooms_arn
      lms_type
      v_ilt_type
      v_ilt_id
      v_ilt_meeting_id
      registrationCounter
      instructor_notes {
        description
        timestamp
        updated_by
        __typename
      }
      csat {
        overall_score
        instructor_score
        completed_responses
        __typename
      }
      __typename
    }
  }
`;
export const getClassAttendance = /* GraphQL */ `
    query GetClassAttendance($input: GetClassAttendanceInput!) {
        getClassAttendance(input: $input) {
            learningActivityAttendanceRecords {
                learner {
                    id
                    emailAddress
                    firstName
                    lastName
                    licenses {
                        nodes {
                            id
                            productModality
                            licenseType
                            __typename
                        }
                        __typename
                    }
                    organizations {
                        nodes {
                            id
                            name
                            sfdcAccountId
                            __typename
                        }
                        __typename
                    }
                    evaluationStatus
                    __typename
                }
                learningActivityAttendanceStatus
                deliverySessionAttendanceRecords {
                    id
                    version
                    attendanceStatus
                    attendanceDurationPercentage
                    learner {
                        id
                        emailAddress
                        firstName
                        lastName
                        licenses {
                            nodes {
                                id
                                productModality
                                licenseType
                                __typename
                            }
                            __typename
                        }
                        organizations {
                            nodes {
                                id
                                name
                                sfdcAccountId
                                __typename
                            }
                            __typename
                        }
                        __typename
                    }
                    amsDeliverySession {
                        id
                        startTime
                        endTime
                        learningActivity {
                            pk
                            attendedCounter
                            activity_audience
                            activity_modality
                            activity_name
                            activity_status
                            activity_type
                            class_size
                            course_name
                            customers {
                                customer_name
                                sfdc_account_id
                                __typename
                            }
                            delivery_address_1
                            delivery_address_2
                            delivery_city
                            delivery_country
                            delivery_geo
                            delivery_language
                            delivery_postal_code
                            delivery_region
                            delivery_sessions {
                                id
                                start_timestamp
                                end_timestamp
                                __typename
                            }
                            delivery_state
                            delivery_timezone
                            instructors {
                                role
                                pk
                                type
                                email
                                __typename
                            }
                            program
                            record_type
                            classrooms_student_url
                            classrooms_arn
                            lms_type
                            v_ilt_type
                            v_ilt_id
                            v_ilt_meeting_id
                            registrationCounter
                            instructor_notes {
                                description
                                timestamp
                                updated_by
                                __typename
                            }
                            csat {
                                overall_score
                                instructor_score
                                completed_responses
                                __typename
                            }
                            __typename
                        }
                        __typename
                    }
                    __typename
                }
                __typename
            }
            pageInfo {
                cursor
                size
                __typename
            }
            __typename
        }
    }
`;
export const getFeatureFlags = /* GraphQL */ `
  query GetFeatureFlags {
    getFeatureFlags {
      flag
      enabled
      __typename
    }
  }
`;
export const batchGetUserInfo = /* GraphQL */ `
  query BatchGetUserInfo($input: BatchGetUserInfoInput!) {
    batchGetUserInfo(input: $input) {
      users {
        id
        emailAddress
        firstName
        lastName
        licenses {
          nodes {
            id
            productModality
            licenseType
            __typename
          }
          __typename
        }
        organizations {
          nodes {
            id
            name
            sfdcAccountId
            __typename
          }
          __typename
        }
        __typename
      }
      failedUsers {
        id
        error
        __typename
      }
      __typename
    }
  }
`;
